import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router } from '@angular/router';
import { AuthService } from '../../../../../core/services/auth.service';

@Injectable()
export class CarrierProfileGuard  {
  constructor(private authService: AuthService, private router: Router) {}

  canActivate(route: ActivatedRouteSnapshot) {
    const accessTokenIsValid = this.authService.userHasValidAccessToken();

    if (accessTokenIsValid) {
      return true;
    } else {
      if (!accessTokenIsValid && route.url.length > 0) {
        this.router.navigateByUrl(
          `/login/carriers/my-profile?certificateId=${route.queryParams['certificateId']}`,
        );
      } else {
        this.router.navigate(['/']);
      }

      return false;
    }
  }
}
